
<template>
 <div class="HomePage">
  <!-- Marquee section - uncomment to restore
  <div class="break"></div>
  <MarqueeText></MarqueeText>
  <div class="break"></div>
  -->

  <!-- Desktop quote bar - hidden on mobile -->


 <section ref="hero" class="hero-section">
   <div class="hero-card">
     <p class="eyebrow">Niles, Michigan Roofing Services</p>
     <h1>Residential & Commercial Roofing Contractor in Niles, MI</h1>
     <p class="hero-intro">Proudly serving communities across the Great Lakes State</p>

     <div class="hero-actions">
       <a href="tel:+12692625055" class="hero-phone-link">📞 Call (269) 262-5055</a>
     </div>

     <ul class="trust-points">
       <li>Locally Owned and Operated</li>
       <li>Licensed and insured for your protection</li>
       <li>Financing Options Available</li>
       <li>High-quality materials and workmanship</li>
       <li>Free estimates and competitive pricing</li>
       <li>Roofing repair services available</li>
       <li>Customer satisfaction guaranteed</li>
     </ul>

     <div class="hero-quote-actions">
       <ContactForm variant="hero"></ContactForm>
     </div>
   </div>
 </section>

 <div v-if="showContactForm" class="floatingContact">
   <ContactForm :modal="this.modal"></ContactForm>
 </div>

   <!-- Main content wrapper with gradient background -->
   <div class="main-content-wrapper">
   <div class="break"></div>
   <div class="Services">
    <span class="ServicesTitle">Check out our Google Reviews!</span>
    <CustomerTestimonials/>
   </div>
   <div class="break"></div>
    <IdentityPage/>
   <div class="break"></div>
    <LicensedInsured/>
    <AwardsPage/>
  <div class="break"></div>
  <div class="Services">    <span class="ServicesTitle">Niles & Southwest Michigan Service Area</span>
    <p class="section-intro">
      We proudly serve homeowners throughout Southwest Michigan, including:
    </p>
    <ul class="service-area-list">
      <li v-for="area in serviceAreas" :key="area">{{ area }}</li>
    </ul>
    <div class="map-embed">
      <iframe
        src="https://www.google.com/maps?q=Niles,+MI+49120&z=10&output=embed"
        title="Map of Homes Roofing Co service area covering Niles and Southwest Michigan"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen>
      </iframe>
    </div>
   </div>
   <div class="break"></div>
   <div class="Services">   <span class="ServicesTitle">Services</span>
   <div class="serviceSelection">
     <PhotoCard v-for="(service, index) in services" :key="index"
     :Services="service" @click="goToPage(service.path)">
    </PhotoCard>
   </div>
   <div class="break"></div>
   <DonateCTA/>

 </div>
 <div class="break"></div>
 <div id="footer">
   <PageFooter :transparentBackground="true"/>
 </div>
 </div>
 <!-- End main content wrapper -->

 </div>
 </template>
 
 <script>
 import ContactForm from '@/components/ContactForm.vue';
 import PhotoCard from '@/components/NewServiceSelector.vue';
 import PageFooter from '@/components/PageFooter.vue';
 import LicensedInsured from '@/components/LicensedInsured.vue';
 import IdentityPage from '@/components/IdentityPage.vue';
 import AwardsPage from '@/components/AwardsPage.vue';
 import CustomerTestimonials from '@/components/CustomerTestimonials.vue';
 import DonateCTA from '@/components/DonateCTA.vue';
 import { upsertJsonLd, removeJsonLd, BASE_URL, DEFAULT_IMAGE } from '@/utils/seo';
 
 export default {
   name: 'HomePage',
   data(){
     return{
       modal: false,
       services: [

       {
         imageSrc: require('@/assets/RoofingRepairPhoto.card.webp'),
         title: 'Full Roof Replacements',
          path: '/roofing-projects',
       },

       {
         imageSrc: require('@/assets/FasciaSoffit/Roof1.card.webp'),
         title: 'Fascia & Soffit',
         path: '/fascia-soffit',
       },

       {
         imageSrc: require('@/assets/Repairs/Repair1.card.webp'),
         title: 'Roofing Repairs',
         path: '/repair-projects',
       },

     ],
     serviceAreas: [
       'Niles',
       'Buchanan',
       'Berrien Springs',
       'Dowagiac',
       'Edwardsburg',
       'St. Joseph',
       'Cassopolis'
     ],
     showContactForm: true,
     isMobile: window.innerWidth <= 1024,
     }
   },
 
   components: {
     ContactForm,
     PhotoCard,
     PageFooter,
     LicensedInsured,
    CustomerTestimonials,
    IdentityPage,
    AwardsPage,
    DonateCTA
   },
   mounted() {
     upsertJsonLd('home-local-business', {
       "@context": "https://schema.org",
       "@type": "RoofingContractor",
       "name": "Homes Roofing Co LLC",
       "@id": `${BASE_URL}/#roofing-contractor`,
       "image": DEFAULT_IMAGE,
       "logo": DEFAULT_IMAGE,
       "description": "Professional roofing contractor based in Niles and proudly serving communities across Michigan with roof replacement, repairs, fascia, soffit, gutters, and siding. 50-year warranty available.",
       "address": {
         "@type": "PostalAddress",
         "addressLocality": "Niles",
         "addressRegion": "MI",
         "postalCode": "49120",
         "addressCountry": "US"
       },
       "geo": {
         "@type": "GeoCoordinates",
         "latitude": "42.2917",
         "longitude": "-85.5872"
       },
       "telephone": "+1-269-262-5055",
       "email": "homesroofingco@gmail.com",
       "url": BASE_URL,
       "sameAs": [
         "https://www.facebook.com/profile.php?id=100091999461722"
       ],
       "priceRange": "$$$",
       "areaServed": [
         "Niles",
         "Buchanan",
         "Berrien Springs",
         "Dowagiac",
         "Edwardsburg",
         "St. Joseph",
         "Cassopolis"
       ].map((city) => ({
         "@type": "City",
         "name": city,
         "containedInPlace": {
           "@type": "State",
           "name": "Michigan"
         }
       })),
       "serviceType": [
         "Roof Replacement",
         "Roof Repair",
         "Fascia Installation",
         "Soffit Installation",
         "Gutter Installation",
         "Siding Installation"
       ],
       "aggregateRating": {
         "@type": "AggregateRating",
         "ratingValue": "5",
         "reviewCount": "50"
       },
       "hasCredential": [
         "Master Craftsman Certified",
         "Shingle Master Certified",
         "EPA Lead-Safe Certified"
       ]
     });

     upsertJsonLd('home-website', {
       '@context': 'https://schema.org',
       '@type': 'WebSite',
       '@id': `${BASE_URL}/#website`,
       name: 'Homes Roofing Co',
       url: BASE_URL,
       description: 'Roof repair and roof replacement services across Michigan, including Gaylord and Niles.',
       potentialAction: {
         '@type': 'SearchAction',
         target: `${BASE_URL}/?q={search_term_string}`,
         'query-input': 'required name=search_term_string'
       }
     });
   },
   beforeUnmount() {
     removeJsonLd('home-local-business');
     removeJsonLd('home-website');
   },
   methods: {
   goToPage(path) {
      this.$router.push(path);
    },
 },

 }
 </script>
 
 <style>
  .HomePage {
    margin-top: 93px;
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    color: #ffffff;
  }

  /* Main content wrapper with gradient background */
  .main-content-wrapper {
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    width: 100%;
  }
  
  @media (max-width: 1024px) {
    .HomePage {
    margin-top: 90px;
  } 

 }

.hero-section {
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;
  padding-top: 70px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof Mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  max-width: none;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
}

@media (min-width: 1025px) {
  .hero-section {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof.webp');
    min-height: 82vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 70px;
  }
}

.hero-card {
  max-width: 920px;
  margin: 0 auto;
  padding: 30px;
  background: rgba(255, 255, 255, 0.07);
  border-left: 5px solid #f1c40f;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.hero-card .eyebrow {
  font-size: clamp(0.7rem, 1vw + 0.3rem, 0.875rem);
  color: #f1c40f;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 700;
  margin-bottom: 15px;
}

.hero-card h1 {
  font-size: clamp(1.75rem, 3.5vw + 0.5rem, 3rem);
  color: #f1c40f;
  margin: 0 0 25px;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
  font-family: 'Roboto Slab', sans-serif;
}

.hero-card .hero-intro {
  font-size: clamp(0.95rem, 1vw + 0.5rem, 1.12rem);
  line-height: 1.8;
  color: #e8e8e8;
  max-width: 820px;
  margin: 0 auto 10px;
  font-family: 'Roboto', sans-serif;
}

.hero-section .hero-actions {
  display: flex;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  margin: 25px 0 30px;
}

.hero-phone-link {
  display: inline-block;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: clamp(0.875rem, 1vw + 0.4rem, 1.05rem);
  font-weight: bold;
  text-decoration: none;
  color: #fff;
  background-color: #8d0808;
  transition: all 0.3s ease;
}

.hero-phone-link:hover {
  background-color: #b30f12;
  transform: translateY(-2px);
}

.trust-points {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  text-align: left;
}

.trust-points li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: clamp(14px, 2.5vw, 18px) clamp(14px, 3vw, 20px);
  background: rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  border-left: 4px solid #f1c40f;
  color: #f5f5f5;
  font-size: clamp(0.95rem, 1.8vw + 0.3rem, 1.05rem);
  line-height: 1.6;
}

.trust-points li::before {
  content: "✓";
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background: #f1c40f;
  color: #1a1a1a;
  font-size: 0.8rem;
  font-weight: 900;
  margin-top: 1px;
}

@media (max-width: 600px) {
  .trust-points {
    grid-template-columns: 1fr;
  }

  .trust-points li {
    padding: 14px 16px;
    gap: 10px;
  }
}

.hero-quote-actions {
  margin-top: 10px;
}

@media (max-width: 880px) {
  .hero-section {
    padding: 24px 20px;
  }
}

.ServicesTitle{
 color: #f1c40f;
   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
   letter-spacing: 1px;
   font-size: 2.2em;
   position: relative;
   z-index: 2;
   padding-bottom: 10px;
   border-bottom: 3px solid #f1c40f;
   display: inline-block;
}

.Bold{
 font-weight: bold;
}

.Services{
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
   display: flex;
   flex-direction: column;
   background: transparent;
   text-align: center;
}


.Services .Title {
 width: 100%;
 display: flex;
 justify-content: center;
 padding: 15px;
 font-size: -webkit-xxx-large;
}.services-wide {
  max-width: 1300px;
}
.serviceSelection {
 display: flex;
 justify-content: center;
 flex-direction: row;
 flex-wrap: wrap;
 gap: 20px;
 margin-top: 25px;
}

.section-intro {
    font-size: clamp(0.95rem, 1vw + 0.5rem, 1.12rem);
    line-height: 1.8;
    color: #e8e8e8;
}

.service-area-list {
    list-style: none;
    padding: 0;
    margin: 20px auto 0;
    max-width: 900px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
}

.service-area-list li {
    padding: 10px 18px;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 999px;
    border: 1px solid rgba(241, 196, 15, 0.4);
    color: #f5f5f5;
    font-size: clamp(0.85rem, 1vw + 0.3rem, 0.98rem);
}

.map-embed {
    width: 100%;
    margin: 25px auto 0;
    max-width: 900px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(241, 196, 15, 0.4);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.map-embed iframe {
    display: block;
    width: 100%;
    height: 320px;
    border: 0;
}

@media (max-width: 600px) {
    .map-embed iframe {
        height: 260px;
    }
}

.photo-card {
   display: flex;
   flex-direction: column;
  color: #f5f5f5;
   justify-content: center;
   align-items: center;
}


.HomeImage{
 height: 100%;
 width: 100%;
 border-radius: 10px;
 object-fit: cover;

 @media (max-width: 1024px) {
   margin-bottom: 20px;

 }
}
.break{
 width: 100%;
 border-bottom: #f1c40f .2em solid;
}
.show-contact-form {
 position: fixed;
 bottom: 20px;
 right: 20px;
 display: block;
}
.floatingContact {

 .contact-button {

  position: fixed;
  bottom: max(16px, env(safe-area-inset-bottom));
  right: max(16px, env(safe-area-inset-right));
  background: linear-gradient(145deg, #a10d10 0%, #d3181c 100%);
  color: white;
  border: 2px solid rgba(241, 196, 15, 0.95);
  border-radius: 999px;
  min-width: 176px;
  max-width: 220px;
  height: 56px;
  padding: 0 18px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  gap: 0;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4), 0 0 0 0 rgba(241, 196, 15, 0.55);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  animation: ctaAttention 5.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  z-index: 100;

   @media (max-width: 500px){
    min-width: 160px;
    height: 52px;
    font-size: 0.86rem;
    padding: 0 14px;
   }
  }

  .financing-button {
    display : none;
}
}
.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 0.5px; /* Add some letter spacing */
 text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.55);
 color: #e8e8e8; /* White text */
}

.floatingContact .contact-button:hover {
  transform: translateY(-2px);
  background: linear-gradient(145deg, #b41013 0%, #e01f24 100%);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.45), 0 0 0 6px rgba(241, 196, 15, 0.14);
}

.floatingContact .contact-button:active {
  transform: translateY(0);
}

.floatingContact .contact-button:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .floatingContact .contact-button {
    transition: none;
    animation: none;
  }
}

@keyframes ctaAttention {
  0%, 72%, 100% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(-1px) scale(1.02);
  }
  18% {
    transform: translateY(0);
  }
}

 
 </style>